(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.onScroll();
    }

    setHeaderHeight() {
      const h = this.header ? this.header.offsetHeight : (this.offsetHeight || 80);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const threshold = 20;

      if (scrollTop > threshold) {
        this.classList.add('scrolled-past-header');
        if (this.header) {
          this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
        }

        if (!this.headerIsAlwaysSticky) {
          // On scroll up sticky behavior
          if (scrollTop > this.currentScrollTop && scrollTop > threshold + 30) {
            // Scrolling down -> hide
            if (this.header) {
              this.header.classList.add('shopify-section-header-hidden');
            }
            this.closeMenuDisclosure();
            this.closeSearchModal();
          } else if (scrollTop < this.currentScrollTop) {
            // Scrolling up -> reveal / open navbar
            if (this.header) {
              this.header.classList.remove('shopify-section-header-hidden');
            }
          }
        }
      } else {
        // At or near top -> header sits below announcement bar, fully transparent
        this.classList.remove('scrolled-past-header');
        if (this.header) {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || (this.header ? this.header.querySelectorAll('header-menu') : []);
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || (this.header ? this.header.querySelector('details-modal') : null);
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
